import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-body d-flex" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "card-text mb-1" }
const _hoisted_4 = { class: "right-section" }
const _hoisted_5 = { class: "text-center mb-3" }
const _hoisted_6 = { class: "text-center mb-4" }
const _hoisted_7 = { class: "d-flex justify-content-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "card mb-3",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('projectSelected', _ctx.project.id))),
      style: {"cursor":"pointer"}
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "left-section",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('projectSelected', _ctx.project.id)))
        }, [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.project.project_name), 1)
        ]),
        _createElementVNode("div", {
          class: "center-section",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('projectSelected', _ctx.project.id)))
        }, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.address")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.fullAddress) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.owner")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.project.client_email) + " ", 1),
            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.created")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.project.created_at)) + " ", 1),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.lastModified")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.project.updated_at)) + " ", 1),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.capacity")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.project.total_power) + " kW ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDuplicate && _ctx.handleDuplicate(...args)), ["stop"])),
            class: "btn btn-warning btn-sm me-2"
          }, _toDisplayString(_ctx.$t("project.actions.duplicate")), 1),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showDeleteModal = true), ["stop"])),
            class: "btn btn-danger btn-sm"
          }, _toDisplayString(_ctx.$t("project.actions.delete")), 1)
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showDeleteModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDeleteModal = false))
          }, [
            _createElementVNode("div", {
              class: "modal-content",
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("project.deleteModal.title")), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("project.deleteModal.message")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteModal = false)),
                  class: "btn btn-secondary px-4"
                }, _toDisplayString(_ctx.$t("project.deleteModal.cancel")), 1),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args))),
                  class: "btn btn-danger px-4"
                }, _toDisplayString(_ctx.$t("project.deleteModal.delete")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}